import React from 'react';

/**
 * Backdrop — ambient background layer: three slow-drifting radial-gradient
 * blobs (90–130s ease-in-out loops, transform-only, very low alpha).
 * Non-distracting by design; looping motion is disabled under
 * prefers-reduced-motion (see styles/globals.css).
 *
 * Layering: fixed, z-0, pointer-events-none — render it as the first child
 * of the app and give the content wrapper `relative z-10`.
 */
export const Backdrop: React.FC = () => (
  <div className="mash-backdrop" aria-hidden="true">
    <div className="mash-backdrop-blob mash-backdrop-blob-a" />
    <div className="mash-backdrop-blob mash-backdrop-blob-b" />
    <div className="mash-backdrop-blob mash-backdrop-blob-c" />
  </div>
);
